import React from "react";
import s from "./VerificationDocument.module.scss";
import Card from "./Card/Card";
import { useQuery } from "../../../../../../libs/common";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import { UserProfile } from "../../../../../../libs/Utils/Types/User";
import useSWR from "swr";
import { swrFetcher } from "../../../../../../libs/api/Endpoints";

import { Skeleton } from "antd";
function VerificationDocument() {
  const query = useQuery();
  const userId = query.get("userId");
  const token = UseAuthToken();
  const { data, isLoading, mutate } = useSWR<{ data: UserProfile }, any, any>(
    token ? [`api/admin/users/${userId}`, token] : null,
    swrFetcher,

    {
      revalidateOnFocus: true, // Refetch when the window regains focus
      // Refetch every 10 seconds (10000 ms)
      shouldRetryOnError: false, // Disable retrying on errors
    },
  );
const allVerifications = [
  ...(data?.data?.otherVerifications ?? []),
  ...(data?.data?.failedVerifications ?? []),
];

  type VerificationType = "business_certificate" | "proof_of_address";

const resolveVerification = (type: VerificationType) => {
  const docs = allVerifications
    .filter(d => d.type === type)
    .sort(
      (a, b) =>
        new Date(b.createdAt).getTime() -
        new Date(a.createdAt).getTime()
    );

  const approved = docs.find(d => d.status === "approved");
  if (approved) return approved;

  const pending = docs.find(d => d.status === "pending");
  if (pending) return pending;

  return docs[0] ?? null; // latest failed
};


 
  const businessCert = resolveVerification("business_certificate");;

  const proofOfAddress = resolveVerification("proof_of_address");
  if (isLoading) {
    return (
      <div className={s.documents}>
        <Skeleton.Node
          active={true}
          rootClassName={s.cardSkeleton}
          className={s.cardSkeleton}
        />
        <Skeleton.Node
          active={true}
          rootClassName={s.cardSkeleton}
          className={s.cardSkeleton}
        />
      </div>
    );
  }
  return (
    <>
      <div className={s.wrapper}>
        <div className={s.head}>
          <h3 className={s.doc}>Documents</h3>
        </div>
        <div className={s.documents}>
          {!businessCert?.mediaUrls.length ? (
            <div className={s.card}>
              <p> No document found</p>
            </div>
          ) : (
            <Card
              mutate={mutate}
              id={businessCert?.id}
              src={businessCert?.mediaUrls}
              userId={userId}
              nameOfDoc="Profile picture"
              status={businessCert?.status}
              text={
                businessCert?.status === "pending"
                  ? "Pending review"
                  : businessCert?.status === "rejected"
                    ? "Rejected"
                    : "Approved"
              }
            />
          )}
          {!proofOfAddress?.mediaUrls.length ? (
            <div className={s.card}>
              <p> No document found</p>
            </div>
          ) : (
            <Card
              mutate={mutate}
              id={proofOfAddress?.id}
              userId={userId}
              src={proofOfAddress?.mediaUrls}
              nameOfDoc="Identification card"
              status={proofOfAddress?.status}
              text={
                proofOfAddress?.status === "pending"
                  ? "Pending review"
                  : proofOfAddress?.status === "rejected"
                    ? "Rejected"
                    : "Approved"
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export default VerificationDocument;
